import { useQuery } from 'react-query';
import { designHuddleService, taxonService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useDesignHuddleProjects = (
  clinid: string | undefined,
  sku: string
) => {
  return useQuery(
    [`${ServerStateKeysEnum.designHuddleProjects}`, sku],
    () => {
      return designHuddleService.getProjects(clinid, sku);
    },

    { staleTime: Infinity, enabled: !!clinid }
  );
};
